export interface AppThemeColors {
  primary: string;
  secondary: string;
  backgroundDefault: string;
  backgroundPaper: string;
}

export interface AppTheme {
  id: string;
  name: string;
  light: AppThemeColors;
  dark: AppThemeColors;
}

export const appThemes: AppTheme[] = [
  {
    id: 'default',
    name: 'Default',
    light: {
      primary: '#1976d2',
      secondary: '#9c27b0',
      backgroundDefault: '#f5f5f5',
      backgroundPaper: '#ffffff',
    },
    dark: {
      primary: '#90caf9',
      secondary: '#ce93d8',
      backgroundDefault: '#121212',
      backgroundPaper: '#1e1e1e',
    },
  },
  {
    id: 'ocean',
    name: 'Ocean',
    light: {
      primary: '#006994',
      secondary: '#0097a7',
      backgroundDefault: '#e0f7fa',
      backgroundPaper: '#f5fdff',
    },
    dark: {
      primary: '#4dd0e1',
      secondary: '#26c6da',
      backgroundDefault: '#0a1929',
      backgroundPaper: '#0d2137',
    },
  },
  {
    id: 'forest',
    name: 'Forest',
    light: {
      primary: '#2e7d32',
      secondary: '#558b2f',
      backgroundDefault: '#f1f8e9',
      backgroundPaper: '#f9fff5',
    },
    dark: {
      primary: '#66bb6a',
      secondary: '#9ccc65',
      backgroundDefault: '#0d1f0d',
      backgroundPaper: '#132513',
    },
  },
  {
    id: 'sunset',
    name: 'Sunset',
    light: {
      primary: '#e65100',
      secondary: '#c62828',
      backgroundDefault: '#fff3e0',
      backgroundPaper: '#fffaf5',
    },
    dark: {
      primary: '#ff8a50',
      secondary: '#ef9a9a',
      backgroundDefault: '#1a0a00',
      backgroundPaper: '#2a1500',
    },
  },
  {
    id: 'lavender',
    name: 'Lavender',
    light: {
      primary: '#7b1fa2',
      secondary: '#4a148c',
      backgroundDefault: '#f3e5f5',
      backgroundPaper: '#fdf5ff',
    },
    dark: {
      primary: '#ce93d8',
      secondary: '#ba68c8',
      backgroundDefault: '#1a0a2e',
      backgroundPaper: '#241040',
    },
  },
  {
    id: 'slate',
    name: 'Slate',
    light: {
      primary: '#37474f',
      secondary: '#546e7a',
      backgroundDefault: '#eceff1',
      backgroundPaper: '#f8fafc',
    },
    dark: {
      primary: '#90a4ae',
      secondary: '#b0bec5',
      backgroundDefault: '#121c24',
      backgroundPaper: '#1e2832',
    },
  },
];

export const DEFAULT_THEME_ID = 'default';

export const getThemeById = (id: string): AppTheme =>
  appThemes.find((t) => t.id === id) ?? appThemes[0];
